import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { logScoreEvent } from "../Analytics/AnalyticsEvent";
import RatingGray from "./../assets/icons/star_gray.png";
import back from "./../assets/icons/back.png";
import "./BannerGame.scss";
import { Link } from "react-router-dom";
import defaultImage from "../assets/images/default-image.png";
import { reactLocalStorage } from "reactjs-localstorage";
import config, { getHeaders } from "../config";
import { logEvent } from "../Analytics/AnalyticsEvent";
import { events, screen } from "../Analytics/EventName";
import RatingYellow from "./../assets/icons/complete.png";
import RatingQuatar from "./../assets/icons/quatar.png";
import RatingHalf from "./../assets/icons/half.png";
import { FaPlay } from "react-icons/fa";
import { logEventHome } from "../Analytics/AnalyticsEvent";
import { SendGuiDataEvents } from "../commonScript";
function BannerGame(props) {
  console.log(">>>props::", props);
  const { game, color, play_btn_txt, loading, setLoading } = props;
  let history = useHistory();
  const {
    id,
    bannerImage,
    gameName,
    gamePlayed,
    ratings,
    url,
    gameDescription,
  } = game;
  const [showMore, setShowMore] = useState(false);
  const gamePlayEvent = async () => {
    let guiPlayEvents = {};
    guiPlayEvents["w_action"] = "game_visit";
    guiPlayEvents["game_name"] = game.gameName;
    guiPlayEvents["game_id"] = game.id;
    guiPlayEvents["game_category"] = game.category;
    await SendGuiDataEvents(guiPlayEvents, game.url);
    setTimeout(() => {
      window.open(game.url, "_self");
    }, 2000);
  };

  function update() {
    setLoading(true);
    const msisdn = reactLocalStorage.get("msisdn");
    const uid = reactLocalStorage.get("uid");
    const url = `${config.get("base")}${config.get("scoreUpdate")}`;
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        uid: uid,
        gameId: game.id,
        gameName: game.gameName,
      }),
      headers: config.get("headers"),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (result) => {
          logScoreEvent(
            {
              screen: screen.gamePage,
              event: "score_api_success_" + events.gamePlayClick,
            },
            {
              status: result.status ? result.status : "NA",
              gameId: id,
              uid: reactLocalStorage.get("uid")
                ? reactLocalStorage.get("uid")
                : "NA",
            }
          );
          console.log("result message::", result);
        },
        (error) => {
          setLoading(false);
          console.log("error:::", error);
        }
      );
  }

  function rating(number) {
    const num = parseFloat(number);
    let newArray = Array(5)
      .fill()
      .map((_, i) => {
        return (
          <img
            key={i}
            src={RatingYellow}
            alt="stars"
            className="mr-1 rating-icon"
          />
        );
      });
    newArray[4] =
      num == 4 ? (
        <img src={RatingGray} alt="stars" className="mr-1 rating-icon" />
      ) : num >= 4.0 && num <= 4.2 ? (
        <img src={RatingQuatar} alt="stars" className="mr-1 rating-icon" />
      ) : num >= 4.3 && num <= 4.5 ? (
        <img src={RatingHalf} alt="stars" className="mr-1 rating-icon" />
      ) : num >= 4.5 && num <= 4.7 ? (
        <img src={RatingHalf} alt="stars" className="mr-1 rating-icon" />
      ) : (
        <img src={RatingYellow} alt="stars" className="mr-1 rating-icon" />
      );
    return newArray;
  }
  function addDefaultSrc(e) {
    e.target.src = defaultImage;
  }

  function handleClick(gameUrl, gameId, gameName) {
    // checkSub()
    console.log("game.gameName", game.gameName);
    logEvent(
      {
        screen: screen.gamePage,
        event: game.gamePlayClick,
      },
      {
        gameId: game.gameId,
        mobile: reactLocalStorage.get("uid")
          ? reactLocalStorage.get("uid")
          : "NA",
      }
    );
    const subStatus = reactLocalStorage.get("subStatus");
    console.log("subStatus is::", subStatus);
    if (subStatus === "active") {
      gamePlayEvent();
      update(gameId, gameName);
    } else {
      if (config.get("domain") === "btc") {
        const url = `${config.get("base")}${config.get("appConfig")}`;
        fetch(url, {
          method: "POST",
          body: JSON.stringify({
            mcc: "652",
            mnc: "04",
            uid: reactLocalStorage.get("uid")
              ? reactLocalStorage.get("uid")
              : "",
          }),
          headers: getHeaders(),
        })
          .then((res) => {
            if (!res.ok) {
              throw res;
            }
            return res.json();
          })
          .then(
            (result) => {
              logEventHome(
                {
                  screen: screen.gamePage,
                  event: "redirecting_user_" + events.gamePlayClick,
                },
                {
                  status: result.status ? result.status : "NA",
                  uid: reactLocalStorage.get("uid")
                    ? reactLocalStorage.get("uid")
                    : "NA",
                }
              );
              let redirect_url =
                result?.sub_url + "?sid=" + localStorage.getItem("sessionId");
              const rc_id =
                localStorage.getItem("rcid") ||
                sessionStorage.getItem("rcid");
              const camp_id =
                localStorage.getItem("camp") ||
                sessionStorage.getItem("camp");

              if (rc_id) {
                redirect_url += "&rcid=" + rc_id;
              }
              if (camp_id) {
                redirect_url += "&camp=" + camp_id;
              }
              console.log("redirect_url::", redirect_url);
              window.open(redirect_url, "_self");
            },
            (error) => {
              console.log("error:::", error);
            }
          );
      } else {
        reactLocalStorage.set("gameUrl", gameUrl);
        history.push("/subscribe");
      }
    }
  }

  return (
    <div className=" is-gapless pagebanner" style={{ minHeight: "50vh" }}>
      <div className=" p-r">
        <Link to="/home" className="navitem">
          <img src={back} alt="back to home" />
        </Link>
        <figure className="lazy-image image">
          <img src={bannerImage} onError={addDefaultSrc} alt="demo" />
        </figure>
        <div className="fixb">
          <div
            className="media"
            style={{
              width: "100%",
              whiteSpace: "break-spaces",
              bottom: "-2rem",
            }}
          >
            <div
              className="media-left"
              style={{ textAlign: "left", marginTop: "25vh", width: "65%" }}
            >
              <h5 className="title is-capitalized is-5 pb-2 has-text-white mb-4">
                {gameName}
              </h5>
              <h6 className="subtitle is-7 has-text-white mb-1 text-lg">
                {gamePlayed}
              </h6>
              <div className="rating has-text-white">
                {rating(ratings)}
                <small className="has-text-weight-dark">{ratings}</small>
              </div>
            </div>
            <div className="media-right">
              <div onClick={() => handleClick(url, gameName, id)}>
                <div className="playBtn display">
                  <FaPlay color={color} className="m-auto" />
                  <span style={{ color: color }} className="m-auto align bold">
                    {play_btn_txt}
                  </span>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="column mt-4">
        <div className="p-2">
          <p className="subtitle is-6 has-text-white game-desc">
            {game.gameDescription.length <= 200
              ? game.gameDescription
              : `${
                  game.gameDescription.length > 200 && showMore
                    ? `${game.gameDescription}`
                    : `${game.gameDescription.substring(0, 200)} ...`
                }`}
            {game.gameDescription.length > 200 && (
              <button
                onClick={() => setShowMore(!showMore)}
                className="toggle-btn p-2 mr-2 font-sm pink-btn"
              >
                {!showMore ? "Montre plus" : "Montrer moins"}
              </button>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}

export default BannerGame;
